/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import useStyles from "./style";
import {
  Avatar,
  AvatarBadge,
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Image,
  Input,
  Progress,
  Text,
  OrderedList,
  ListItem,
  IconButton as ChakraIconButton,
} from "@chakra-ui/react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Header from "components/header";
import Footer from "components/footerUser";
import {
  FormControlLabel,
  LinearProgress,
  Radio,
  RadioGroup,
} from "@mui/material";
import { CloseIcon, Search2Icon } from "@chakra-ui/icons";
import PersonIcon from "@mui/icons-material/Person";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Add from "../../assets/img/add.png";
import PersonSvg from "../../assets/svg/person.js";
import MatchingIcon from "../../assets/img/MatchingIcon.png";

import MatchingPartnership from "../../assets/img/MatchingPartnership.webp";
import MatchingRomance from "../../assets/img/MatchingRomance.webp";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { MdLock } from "react-icons/md";
import PricingMatching from "views/pricingMatching";
import { AccountCircle } from "@mui/icons-material";
import { formatPrice } from "utils/format";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Matching = (props) => {
  const styles = useStyles();
  const [user, setUser] = useState();

  const checkLogin = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.assign("/login?service=matching");
      return false;
    }
    return true;
  };
  const [localUser, setLocalUser] = useState();
  const [user1, setUser1] = useState();
  const [user2, setUser2] = useState();
  const [matchedUser1, setMatchedUser1] = useState();
  const [matchedUser2, setMatchedUser2] = useState();
  const [service, setService] = useState();
  //   const [searchUser1, setSearchUser1] = useState();
  //   const [searchUser2, setSearchUser2] = useState();
  const [visibleSearchUser, setVisibleSearchUser] = useState();
  const [searchData, setSearchData] = useState([]);
  const [activeCard, setActiveCard] = useState(0);
  const [matching, setMatching] = useState();
  const [open, setOpen] = useState("");
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [isShowLimitSave, setIsShowLimitSave] = useState(false);
  const [isShowReplace, setIsShowReplace] = useState(false);
  const [isShowPricing, setIsShowPrincing] = useState(false);
  //   const [matchingCard, setMatchingCard] = useState(0);
  const [matchedMode, setMatchedMode] = useState(null);
  const [mode, setMode] = useState(0);
  const [cardMatching, setCardMatching] = useState([]);
  const [listMatched, setListMatched] = useState([]);
  const [stats, setStats] = useState();
  const [level, setLevel] = useState("");
  const [error, setError] = useState("");
  const [quotaRun, setQuotaRun] = useState(0);
  const [subsRun, setSubsRun] = useState("");
  const [quotaDeep, setQuotaDeep] = useState(0);
  const [matchDay, setMatchDay] = useState(0);
  const [limitMatching, setLimitMatching] = useState(false);
  const [isOpenSubscription, setIsOpenSubscription] = useState(false);
  const [products, setProducts] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");
    let locUser = localStorage.getItem("user");
    setLocalUser(JSON.parse(locUser));
    if (props?.match?.params?.id && props?.match?.params?.type) {
      axios
        .get(
          `https://api.personatalenta.id/user/${props.match.params.type}/${props.match.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
            },
          },
        )
        .then((res) => {
          setUser(res.data.user ?? res.data.colleagues);
        })
        .catch((err) => {
          if (
            err.response?.data?.message === "Unauthorized" ||
            err.response?.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    } else {
      if (locUser) {
        setUser(JSON.parse(locUser));
      } else {
        setUser("guess");
        // window.location.assign('/home')
      }
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`https://api.personatalenta.id/product/list`, {
        headers: {
          Authorization: `Bearer ${token ? token : ""}`,
          "Content-Type": "x-www-from-urlencode",
        },
      })
      .then((res) => {
        if (res.data && res.data.products) {
          setProducts(res.data.products);
        }
      })
      .catch((err) => {
        console.error("Error fetching products:", err);
      });
  }, []);

  useEffect(() => {
    let ignore = false;

    const openElement = () => {
      if (location.hash && !ignore) {
        const item = location.hash.slice(1)?.split("#");
        if (item[0] === "partnership") {
          setMode(0);
        } else if (item[0] === "romance") {
          setMode(1);
        } else if (item[0] === "friendship") {
          setMode(2);
        }
      }
    };

    // Delay the open action to give time for rendering the target element
    const timeoutId = setTimeout(openElement, 500); // 500ms delay

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
      ignore = true;
    };
  }, [location.hash]);

  useEffect(() => {
    if (user !== "guess") {
      const token = localStorage.getItem("token");
      axios
        .get(
          `https://api.personatalenta.id/matching/quota/run-matching?matching_type=${mode}`,
          {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
            },
          },
        )
        .then((res) => {
          setQuotaRun(res.data.quota);
          setSubsRun(res.data.text);
          // setUser(res.data.user ?? res.data.colleagues)
        })
        .catch((err) => {
          if (
            err.response?.data?.message === "Unauthorized" ||
            err.response?.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    }
  }, [user, mode, matching]);

  useEffect(() => {
    if (user !== "guess") {
      const token = localStorage.getItem("token");
      const baseUrl = "https://api.personatalenta.id/user/service/table-list";
      axios
        .get(baseUrl, {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        })
        .then((res) => {
          if (res?.data?.products) {
            setService(res.data.products);
          }
        })
        .catch((err) => {
          if (
            err.response.data.message === "Unauthorized" ||
            err.response.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    }
  }, [user]);

  useEffect(() => {
    if (user !== "guess") {
      const token = localStorage.getItem("token");
      axios
        .get(`https://api.personatalenta.id/matching/list-saved`, {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
            "Access-Control-Allow-Origin": "http://localhost:3000",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
          },
        })
        .then((res) => {
          setListMatched(res.data.data);
        })
        .catch((err) => {
          if (
            err.response?.data?.message === "Unauthorized" ||
            err.response?.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    }
  }, [user]);

  useEffect(() => {
    if (user !== "guess") {
      const token = localStorage.getItem("token");
      axios
        .get(
          `https://api.personatalenta.id/matching/quota/deep-dive?matching_type=${mode}`,
          {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
            },
          },
        )
        .then((res) => {
          setQuotaDeep(res.data.quota);
          // setUser(res.data.user ?? res.data.colleagues)
        })
        .catch((err) => {
          if (
            err.response?.data?.message === "Unauthorized" ||
            err.response?.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    }
  }, [user, mode]);

  useEffect(() => {
    window.onscroll = function () {
      myFunction();
    };

    var navbar = document.getElementById("sticky-guess");
    // var type = document.getElementById("type");
    var sticky = navbar.offsetTop - 100;

    function myFunction() {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky-guess");
        // type.classList.add("sticky")
      } else {
        navbar.classList.remove("sticky-guess");
        // type.classList.remove("sticky");
      }
    }
  }, [window]);

  useEffect(() => {
    if (stats) {
      if (stats < 50) {
        setLevel("Average");
      } else if (stats < 60) {
        setLevel("Moderate");
      } else if (stats < 70) {
        setLevel("Intermediate");
      } else if (stats < 80) {
        setLevel("Leading");
      } else if (stats < 90) {
        setLevel("Advance");
      } else {
        setLevel("The BEST");
      }
    }
  }, [stats]);

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    if (mode === 1) {
      if (user1 && user2) {
        if (user1.gender === user2.gender) {
          setError(
            "Matching Romance hanya berlaku untuk gender yang berbeda saja!!!",
          );
        } else {
          setError("");
        }
      } else {
        setError("");
      }
    } else {
      setError("");
    }
  }, [mode, user1, user2]);

  const isSubscribed = useMemo(() => {
    if (!service?.matching) return false;

    let typeName = "";
    // mode 0 = Partnership, 1 = Romance, 2 = Friendship
    if (mode === 0) typeName = "Partnership Matching";
    else if (mode === 1) typeName = "Romance Matching";
    else if (mode === 2) typeName = "Friendship Matching";

    const category = service.matching.find((item) => item.type === typeName);
    if (category?.data) {
      return category.data.some((product) => product.isPurchase === true);
    }
    return false;
  }, [service, mode]);

  //   useEffect(() => {
  //     setMatching();
  //     setMatchingCard(0);
  //     setCardMatching([]);
  //     setStats()
  //   }, [activeCard])

  const onRunMatching = () => {
    if (!checkLogin()) return;
    const token = localStorage.getItem("token");
    if (token && quotaRun > 0) {
      axios
        .get(
          `https://api.personatalenta.id/matching/run?id1=${user1?.id}&id2=${
            user2?.id
          }&type1=${user1.type ?? 0}&type2=${
            user2.type ?? 0
          }&matching_type=${mode}`,
          {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
            },
          },
        )
        .then((res) => {
          setMatchedUser1(user1);
          setMatchedUser2(user2);
          setMatchedMode(mode);
          setMatching(res?.data);
          setCardMatching(res?.data?.cards_general);
          // setMatchingCard(0);
          setStats(res?.data?.stats?.general);
          setActiveCard(1);
          setIsUnlocked(res?.data?.is_unlocked);
          // setCards(res?.data?.cards)
          setTimeout(() => {
            const el = document.getElementById("row-menu");
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }, 100); // delay 100ms agar update state selesai
        })
        .catch((err) => {
          setError(err?.response?.data?.message);
          if (
            err.response?.data?.message === "Unauthorized" ||
            err.response?.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    } else if (token && quotaRun === 0) {
      setLimitMatching(true);
    } else {
      window.location.assign("/login?service=matching");
    }
  };

  const handleClose = () => {
    setShowDialog(false);
  };

  const handleCloseLimit = () => {
    setLimitMatching(false);
  };

  const handleCloseSubscription = () => {
    setIsOpenSubscription(false);
  };

  const handleCloseLimitSave = () => {
    setIsShowLimitSave(false);
  };

  const handleCloseReplace = () => {
    setIsShowReplace(false);
  };

  const handleClosePricing = () => {
    setIsShowPrincing(false);
  };

  const onClickCard = (props) => {
    setActiveCard(props);
    // setMatchingCard(props);
    if (matching) {
      if (props === 1) {
        setCardMatching(matching.cards_general);
        setStats(matching.stats.general);
      } else if (props === 2) {
        setCardMatching(matching.cards_daily);
        setStats(matching.stats.today);
      }
    }
  };

  const onChangeSearch = (text) => {
    const token = localStorage.getItem("token");

    if (token) {
      if (text.target.value.length > 2) {
        if (visibleSearchUser === "colleague") {
          axios
            .get(
              `https://api.personatalenta.id/user/colleague?search=${text.target.value}`,
              {
                headers: {
                  Authorization: `Bearer ${token ? token : ""}`,
                  "Content-Type": "x-www-from-urlencode",
                  "Access-Control-Allow-Origin": "http://localhost:3000",
                  "Access-Control-Allow-Credentials": "true",
                  "Access-Control-Allow-Headers":
                    "Origin, X-Requested-With, Content-Type, Accept",
                },
              },
            )
            .then((res) => {
              setSearchData(res?.data?.colleagues);
              // setCards(res?.data?.cards)
            })
            .catch((err) => {
              if (
                err.response?.data?.message === "Unauthorized" ||
                err.response?.data === "Unauthorized"
              ) {
                // navigate('/');
              }
            });
        } else {
          axios
            .get(
              `https://api.personatalenta.id/user/friendship/find-friend?search=${text.target.value}`,
              {
                headers: {
                  Authorization: `Bearer ${token ? token : ""}`,
                  "Content-Type": "x-www-from-urlencode",
                  "Access-Control-Allow-Origin": "http://localhost:3000",
                  "Access-Control-Allow-Credentials": "true",
                  "Access-Control-Allow-Headers":
                    "Origin, X-Requested-With, Content-Type, Accept",
                },
              },
            )
            .then((res) => {
              setSearchData(res?.data?.users);
              // setCards(res?.data?.cards)
            })
            .catch((err) => {
              if (
                err.response?.data?.message === "Unauthorized" ||
                err.response?.data === "Unauthorized"
              ) {
                // navigate('/');
              }
            });
        }
      } else {
        setSearchData([]);
      }
    }
  };

  const onSelectMe = () => {
    if (!checkLogin()) return;
    if (!user1) {
      setUser1({
        ...user,
        type: props?.match?.params?.type === "colleague" ? "1" : "0",
      });
    } else if (user1 !== user) {
      setUser2({
        ...user,
        type: props?.match?.params?.type === "colleague" ? "1" : "0",
      });
    }
  };

  const onSelectUser = (data, type) => {
    if (!user1) {
      setUser1({ ...data, type: type === "colleague" ? "1" : "0" });
      setVisibleSearchUser(false);
      setSearchData([]);
    } else {
      setUser2({ ...data, type: type === "colleague" ? "1" : "0" });
      setVisibleSearchUser(false);
      setSearchData([]);
    }
  };

  const onRemoveUser = (user) => {
    if (user === 1) {
      setUser1();
    } else if (user === 2) {
      setUser2();
    }
  };

  const onClickOpen = (text) => {
    const list = listMatched.find((item) => item.matching_type === mode);
    if (isUnlocked) {
      if (text === open) {
        setOpen("");
      } else {
        setOpen(text);
      }
    } else {
      if (quotaDeep > 0 && !list) {
        setShowDialog(true);
      } else if (quotaDeep > 0 && list) {
        setIsShowReplace(true);
      } else if (
        quotaDeep < 1 &&
        subsRun.toLowerCase().includes("berlangganan") &&
        list
      ) {
        setIsShowLimitSave(true);
      } else {
        setIsOpenSubscription(true);
      }
    }
  };

  const onChangeUser1 = (e) => {
    let tmpUser = user1 ?? {};
    tmpUser[e.target.name] = e.target.value;
    setUser1(tmpUser);
  };

  const onChangeUser2 = (e) => {
    let tmpUser = user2 ?? {};
    tmpUser[e.target.name] = e.target.value;
    setUser2(tmpUser);
  };

  const onSaveMatching = () => {
    const token = localStorage.getItem("token");
    axios
      .post(
        `https://api.personatalenta.id/matching/deep-dive/${matching.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "content-type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((res) => {
        if (res.data.message === "Success melakukan deep dive") {
          window.location.assign(`/dashboard/profile/matching/${matching.id}`);
        } else {
          setError(res.data.message);
          setShowDialog(false);
        }
      })
      .catch((err) => {
        setError(err.response.data.message || err.response.data);
        setShowDialog(false);
      });
  };

  const onHandleReplace = () => {
    const list = listMatched.find((item) => item.matching_type === mode);
    const token = localStorage.getItem("token");
    axios
      .post(
        `https://api.personatalenta.id/matching/deep-dive/replace`,
        {
          id: list.id,
          new_id: matching.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "content-type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((res) => {
        // if (res.data.message === "Success melakukan deep dive") {
        window.location.assign(`/dashboard/profile/matching/${matching.id}`);
        // } else {
        //   setError(res.data.message);
        //   setIsShowReplace(false);
        // }
      })
      .catch((err) => {
        setError(err.response.data.message || err.response.data);
        setIsShowReplace(false);
      });
  };

  const { color, title } = useMemo(() => {
    switch (mode) {
      case 0:
        return { color: "orange", title: "Partnership" };
      case 1:
        return { color: "#FF0080", title: "Romance" };
      case 2:
        return { color: "blue.500", title: "Friendship" };
    }
  }, [mode]);

  return (
    <div className={styles.app}>
      <Header active="matching" />
      <div className={styles.heroContainer}>
        <Flex maxWidth={1080} width="100%">
          <Box display={{ base: "none", md: "block" }} width="100%">
            <Flex direction={{ sm: "column-reverse", md: "row" }} gap={10}>
              <Flex flex={5} gap={3} direction="column">
                <Flex direction="column" gap={5}>
                  <Flex direction="column">
                    <Flex
                      bgColor={color}
                      borderTopRadius={10}
                      width="100%"
                      py={2}
                      px={3}
                    >
                      <Text
                        color="white"
                        fontWeight="bold"
                        textTransform="uppercase"
                      >
                        {title} Matching
                      </Text>
                    </Flex>
                    <Flex
                      direction="column"
                      borderLeftWidth={1}
                      borderRightWidth={1}
                      borderBottomWidth={1}
                      paddingTop={5}
                      paddingBottom={5}
                      marginBottom={3}
                    >
                      <Text fontWeight="bold">
                        Cara melakukan Matching adalah:
                      </Text>
                      <ol style={{ paddingLeft: "20px" }}>
                        <li>
                          <Text>Pilih Tipe Matching yang Kamu inginkan</Text>
                        </li>
                        <li>
                          <Text>Pilih User yang akan kamu maching:</Text>
                          <ul>
                            <li>
                              <Text>Pilih kamu sendiri, atau</Text>
                            </li>
                            <li>
                              <Text>
                                Pilih User dengan fasilitas Search User Apps,
                                atau
                              </Text>
                            </li>
                            <li>
                              <Text>
                                Pilih Colleague untuk mencari list Colleague
                                yang sudah kamu tambahkan sebelumnya, atau klik
                                icon untuk menambah manual input baru.
                              </Text>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Text>
                            Setelah selesai memasukan user yang di matching,
                            klik button Run The Matching .... Lihat Hasilnya !
                          </Text>
                        </li>
                      </ol>
                    </Flex>
                    <Flex flexDirection="column">
                      <Flex
                        bgColor={color}
                        flexDirection="column"
                        borderTopRadius={10}
                        width="100%"
                        py={2}
                        px={3}
                      >
                        <Text color="white" fontWeight="bold">
                          Benefit Berlangganan
                        </Text>
                      </Flex>
                      <Flex direction="row" gap={3}>
                        <Flex flex={1}>
                          <Button
                            bgColor={matchDay === 0 ? "#3572EF" : "white"}
                            color={matchDay === 0 ? "white" : "#3572EF"}
                            borderWidth={1}
                            borderColor="#3572EF"
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="bold"
                            borderRadius="5px"
                            onClick={() => setMatchDay(0)}
                            flex={{ sm: 1 }}
                            px={{ sm: "10px", md: "30px" }}
                            py="5px"
                          >
                            5 Hari Matching
                          </Button>
                        </Flex>
                        <Flex flex={1}>
                          <Button
                            bgColor={matchDay === 1 ? "#3572EF" : "white"}
                            color={matchDay === 1 ? "white" : "#3572EF"}
                            borderWidth={1}
                            borderColor="#3572EF"
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="bold"
                            borderRadius="5px"
                            onClick={() => setMatchDay(1)}
                            flex={{ sm: 1 }}
                            px={{ sm: "10px", md: "30px" }}
                            py="5px"
                          >
                            10 Hari Matching
                          </Button>
                        </Flex>
                      </Flex>
                      <Flex direction="column" borderWidth={1} marginBottom={3}>
                        {matchDay === 0 ? (
                          <ol style={{ paddingLeft: "20px" }}>
                            <li>
                              <Text>
                                10X Run The Matching langganan per hari.
                              </Text>
                            </li>
                            <li>
                              <Text>
                                1 Hasil Matching Lengkap dapat kamu simpan
                                selama 5 hari berlangganan.
                              </Text>
                            </li>
                            <li>
                              <Text>
                                Kamu bisa mengganti Matching yang tersimpan
                                setiap hari 1X.
                              </Text>
                            </li>
                            <li>
                              <Text>
                                Hasil Matching yang kamu simpan akan expired
                                pada jam 00.00.
                              </Text>
                            </li>
                            <li>
                              <Text>
                                Untuk Jenis Matching yang belum berlangganan
                                kamu hanya dapat melakukan 2X Run The Matching
                                saja.
                              </Text>
                            </li>
                          </ol>
                        ) : (
                          <ol style={{ paddingLeft: "20px" }}>
                            <li>
                              <Text>
                                15 Run The Matching langganan per hari.
                              </Text>
                            </li>
                            <li>
                              <Text>
                                1 Hasil Matching Lengkap dapat kamu simpan
                                selama 10 hari berlangganan.
                              </Text>
                            </li>
                            <li>
                              <Text>
                                Kamu bisa mengganti Matching yang tersimpan
                                setiap hari 1X.
                              </Text>
                            </li>
                            <li>
                              <Text>
                                Hasil Matching yang kamu simpan akan expired
                                pada jam 00.00.
                              </Text>
                            </li>
                            <li>
                              <Text>
                                Untuk Jenis Matching yang belum berlangganan
                                kamu hanya dapat melakukan 2X Run The Matching
                                saja.
                              </Text>
                            </li>
                          </ol>
                        )}
                      </Flex>
                    </Flex>
                    <Flex flexDirection="column" w="100%">
                      <Flex
                        bgColor={color}
                        flexDirection="column"
                        borderTopRadius={10}
                        width="100%"
                        py={2}
                        px={3}
                      >
                        <Text color="white" fontWeight="bold">
                          Manfaat Mengetahui Nilai Matching
                        </Text>
                      </Flex>
                      <Flex
                        flexDirection="column"
                        px={3}
                        py={2}
                        w="100%"
                        gap={2}
                        borderWidth={1}
                      >
                        {mode === 0 ? (
                          <>
                            <Text>
                              Mengetahui ukuran kecocokan dalam partnership -
                              baik itu dalam bisnis, pekerjaan, maupun proyek
                              kolaboratif - memberikan banyak keuntungan yang
                              dapat memengaruhi efektivitas, produktivitas, dan
                              kepuasan kerja. Berikut adalah manfaat-manfaat
                              utamanya:
                            </Text>
                            <ol style={{ paddingLeft: "20px" }}>
                              <li>
                                <Text>
                                  <b>
                                    Membagi tugas sesuai dengan kekuatan
                                    masing-masing.
                                  </b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Mengidentifikasi potensi konflik lebih awal.
                                  </b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Meningkatkan Keputusan yang Lebih Tepat dan
                                    Efektif.
                                  </b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Membuat Strategi Kolaborasi yang Lebih
                                    Efektif.
                                  </b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Pengelolaan Risiko yang Lebih Baik.</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Pengembangan Karier dan Bisnis yang Lebih
                                    Stabil
                                  </b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Mendorong perkembangan karier yang lebih
                                    cepat.
                                  </b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Mengetahui ukuran kecocokan memberikan
                                    manfaat emosional dan psikologis seperti.
                                  </b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Melakukan evaluasi kinerja dengan lebih
                                    objektif.
                                  </b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Kolaborasi menjadi lebih stabil dan bertahan
                                    lebih lama.
                                  </b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Menghasilkan hasil yang lebih memuaskan.
                                  </b>
                                </Text>
                              </li>
                            </ol>
                            <Text>
                              Mengetahui ukuran kecocokan dalam partnership
                              adalah langkah penting untuk memastikan bahwa
                              kerjasama yang dibangun benar-benar produktif dan
                              harmonis. Ini juga memungkinkan kamu dan partnermu
                              untuk memanfaatkan kelebihan masing-masing dan
                              mengelola kelemahan dengan lebih efektif.
                            </Text>
                            <Text fontWeight="bold">
                              Mau dibantu untuk mengetahui cara mengukur ukuran
                              kecocokan dalam partnership kamu? Atau ingin tahu
                              bagaimana mengoptimalkan partnership yang sudah
                              ada?{" "}
                            </Text>
                          </>
                        ) : mode === 1 ? (
                          <>
                            <Text>
                              Manfaat kecocokan dalam hubungan cinta antar
                              pasangan. Ini topik yang penting banget, karena
                              kecocokan itu bisa jadi fondasi utama buat
                              hubungan yang langgeng dan sehat. Yuk, kita bahas
                              manfaatnya dari berbagai sisi:
                            </Text>
                            <ol>
                              <li>
                                <Text>
                                  <b>Komunikasi Lebih Lancar</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Tumbuh Bersama, Bukan Saling Menarik</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Punya Chemistry dan Humor yang Nyambung</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Kehidupan Seksual yang Memuaskan</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Stabilitas dan Keamanan Emosional.</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Saling Mengisi Kekurangan</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Kemungkinan Hubungan Jangka Panjang Lebih
                                    Besar
                                  </b>
                                </Text>
                              </li>
                            </ol>
                            <Text fontWeight="bold">
                              Kalau kamu lagi mikirin soal kecocokan dalam
                              hubungan kamu sendiri atau seseorang di sekitar
                              kamu, aku bisa bantu analisa juga dari situ.
                              Mau?{" "}
                            </Text>
                          </>
                        ) : (
                          <>
                            <Text>
                              Oke, ini juga nggak kalah penting! Kecocokan dalam
                              persahabatan punya manfaat besar yang kadang
                              underrated. Persahabatan yang cocok bisa jadi
                              sumber energi positif, tempat healing, dan bahkan
                              jadi fondasi support system yang kuat.{" "}
                            </Text>
                            <ol>
                              <li>
                                <Text>
                                  <b>Nyambung Saat Ngobrol.</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Bisa Jadi Diri Sendiri.</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Punya Nilai dan Prinsip yang Sejalan.</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Senang Lakukan Hal yang Sama.</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Saling Menguatkan, Bukan Menjatuhkan.</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Nggak Perlu Ketemu Terus Tapi Tetap Dekat.
                                  </b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>Jadi Support System Sejati.</b>
                                </Text>
                              </li>
                              <li>
                                <Text>
                                  <b>
                                    Intinya, kecocokan dalam persahabatan bikin
                                    hubungan lebih kuat, sehat, dan tahan lama.
                                  </b>
                                </Text>
                              </li>
                            </ol>
                            <Text fontWeight="bold">
                              Kalau kamu punya sahabat yang udah cocok banget,
                              jagain baik-baik ya—itu berkah yang nggak semua
                              orang punya. Mau cerita soal sahabat kamu?{" "}
                            </Text>
                          </>
                        )}
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
              <Flex direction="column" flex={7}>
                <Flex
                  position="fixed"
                  width="100%"
                  bgColor="#fff"
                  zIndex={99}
                  maxWidth={600}
                  direction="row"
                  id="sticky-guess"
                  gap={{ sm: 3, md: 5 }}
                  flexWrap="wrap"
                >
                  <Button
                    bgColor={mode === 0 ? "orange" : "white"}
                    color={mode === 0 ? "white" : "orange"}
                    borderWidth={1}
                    borderColor={"orange"}
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                    borderRadius="5px"
                    onClick={() => setMode(0)}
                    flex={{ sm: 1 }}
                    px={{ sm: "10px", md: "30px" }}
                    py="5px"
                  >
                    Partnership
                  </Button>
                  <Button
                    bgColor={mode === 1 ? "#FF0080" : "white"}
                    borderColor={"#FF0080"}
                    borderWidth={1}
                    color={mode === 1 ? "white" : "#FF0080"}
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                    borderRadius="5px"
                    onClick={() => setMode(1)}
                    flex={{ sm: 1 }}
                    px={{ sm: "10px", md: "30px" }}
                    py="5px"
                  >
                    Romance
                  </Button>
                  <Button
                    bgColor={mode === 2 ? "blue.500" : "white"}
                    borderColor={"blue.500"}
                    borderWidth={1}
                    color={mode === 2 ? "white" : "blue.500"}
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                    borderRadius="5px"
                    onClick={() => setMode(2)}
                    flex={{ sm: 1 }}
                    // disabled={cardMatching.length === 0}
                    px={{ sm: "10px", md: "30px" }}
                    py="5px"
                  >
                    Friendship
                  </Button>
                </Flex>
                <Flex
                  borderWidth={1}
                  borderRadius={15}
                  mt={12}
                  py={1}
                  flexDirection="column"
                  gap={5}
                  width={{ sm: "100%" }}
                >
                  {error !== "" && (
                    <Flex justifyContent="center" alignItems="center">
                      <Flex
                        bgColor="white"
                        flexDir="column"
                        justifyContent="center"
                        borderWidth={1}
                        width="80%"
                        borderColor="red"
                        borderStyle="dashed"
                        borderRadius={5}
                        px={3}
                        py={2}
                      >
                        <Text
                          color="red"
                          textAlign="center"
                          fontSize={{ sm: "xs", md: "sm" }}
                        >
                          {error}
                        </Text>
                        <Text
                          color="red"
                          textAlign="center"
                          fontSize={{ sm: "xs", md: "sm" }}
                        >
                          Silahkan coba lagi
                        </Text>
                      </Flex>
                    </Flex>
                  )}
                  {user !== "guess" && (
                    <Flex width="100%" justifyContent="center">
                      <Flex
                        // borderWidth={1}
                        borderRadius={4}
                        px={2}
                        py={1}
                        borderColor="red"
                        borderStyle="dashed"
                      >
                        <Text color="#0046FF">
                          {subsRun} - {quotaRun} kali Matching
                        </Text>
                      </Flex>
                    </Flex>
                  )}
                  {/* {user1 || user2 ? ( */}
                  <Flex
                    flexDirection="row"
                    px={{ sm: 0, md: 32 }}
                    py={0}
                    gap={0}
                    width={{ sm: "100%" }}
                  >
                    <Flex
                      width={"100%"}
                      flexDirection="column"
                      gap={5}
                      px={5}
                      py={5}
                    >
                      {user1 ? (
                        <Flex
                          alignItems="center"
                          gap={1}
                          flexDirection="column"
                        >
                          <Avatar
                            src={user1.photo}
                            h="80px"
                            w="80px"
                            border="2px solid"
                            // borderColor={borderColor}
                          >
                            <AvatarBadge
                              cursor="pointer"
                              onClick={() => onRemoveUser(1)}
                              borderColor="white"
                              bg="red"
                              boxSize="1.5em"
                              top={0}
                              borderRadius={100}
                              color="white"
                            >
                              X
                            </AvatarBadge>
                          </Avatar>
                          <Flex flexDirection="column" textAlign="center">
                            <Text
                              fontSize={{ sm: "xs", md: "sm" }}
                              isTruncated
                              maxWidth="130px"
                            >
                              {user1.name?.slice(0, 10)}
                            </Text>
                            <Text fontSize={{ sm: "xs", md: "sm" }}>
                              {user1.gender == 0 ? "Male" : "Female"}
                            </Text>
                          </Flex>
                        </Flex>
                      ) : (
                        <Flex
                          alignItems="center"
                          gap={1}
                          flexDirection="column"
                        >
                          <PersonSvg
                            color={
                              mode === 0
                                ? "orange"
                                : mode === 1
                                  ? "#FF0080"
                                  : "#3182CE"
                            }
                            sx={{ fontSize: 80 }}
                          />
                          <Text fontSize={{ sm: "xs", md: "sm" }}>User 1</Text>
                        </Flex>
                      )}
                    </Flex>
                    <Flex
                      flexDirection="column"
                      width={"100%"}
                      gap={5}
                      px={5}
                      py={5}
                    >
                      {user2 ? (
                        <Flex
                          alignItems="center"
                          gap={1}
                          flexDirection="column"
                        >
                          <Avatar
                            src={user2.photo}
                            h="80px"
                            w="80px"
                            border="2px solid"
                          >
                            <AvatarBadge
                              cursor="pointer"
                              onClick={() => onRemoveUser(2)}
                              borderColor="white"
                              bg="red"
                              boxSize="1.5em"
                              top={0}
                              borderRadius={100}
                              color="white"
                            >
                              X
                            </AvatarBadge>
                          </Avatar>
                          <Flex flexDirection="column" textAlign="center">
                            <Text
                              fontSize={{ sm: "xs", md: "sm" }}
                              isTruncated
                              maxWidth="130px"
                            >
                              {user2.name?.slice(0, 10)}
                            </Text>
                            <Text fontSize={{ sm: "xs", md: "sm" }}>
                              {user2.gender == 0 ? "Male" : "Female"}
                            </Text>
                          </Flex>
                        </Flex>
                      ) : (
                        <Flex
                          alignItems="center"
                          gap={0}
                          flexDirection="column"
                        >
                          <PersonSvg
                            color={
                              mode === 0
                                ? "orange"
                                : mode === 1
                                  ? "#FF0080"
                                  : "#3182CE"
                            }
                            sx={{ fontSize: 80 }}
                          />
                          <Text fontSize={{ sm: "xs", md: "sm" }}>User 2</Text>
                        </Flex>
                      )}
                    </Flex>
                  </Flex>
                  {/* ) : (
                  <Image
                    src={MatchingIcon}
                    w={{ base: "25px", "3xl": "25px" }}
                    h={{ base: "25px", "3xl": "25px" }}
                    borderRadius="20px"
                  />
                )} */}
                  <Flex flexDirection="column" gap={5}>
                    <Flex gap={3} flexWrap="wrap" width={{ sm: "100%" }}>
                      {visibleSearchUser && user !== "guess" ? (
                        <Flex flexDirection="row" gap={2} width="100%">
                          <Flex flex={11} flexDirection="column">
                            <Input
                              px={3}
                              py={1}
                              borderRadius={5}
                              width="100%"
                              fontSize={{ sm: "xs", md: "sm" }}
                              placeholder="Search by name (min 3 huruf)"
                              onChange={onChangeSearch}
                            />
                            {searchData.length > 0 && (
                              <Flex
                                flexDirection="column"
                                flex={1}
                                gap={2}
                                position="relative"
                              >
                                <Flex
                                  flexDirection="column"
                                  width="100%"
                                  flex={1}
                                  gap={2}
                                  position="absolute"
                                  backgroundColor="#fff"
                                  borderWidth={1}
                                  px={5}
                                  py={2}
                                  zIndex={1}
                                >
                                  {searchData.map((data, index) => (
                                    <Button
                                      key={index}
                                      justifyContent="start"
                                      color={"black"}
                                      fontSize={{ sm: "xs", md: "sm" }}
                                      onClick={() =>
                                        onSelectUser(data, visibleSearchUser)
                                      }
                                      py="5px"
                                    >
                                      <Text isTruncated maxWidth="200px">
                                        {data.name}
                                      </Text>
                                    </Button>
                                  ))}
                                </Flex>
                              </Flex>
                            )}
                          </Flex>
                          <Flex flex={1}>
                            <Button
                              bgColor={"white"}
                              color={"red"}
                              fontSize={{ sm: "xs", md: "sm" }}
                              fontWeight="bold"
                              borderRadius="5px"
                              borderWidth={1}
                              borderColor="red"
                              onClick={() => setVisibleSearchUser(false)}
                              px={{ sm: "10px", md: "30px" }}
                              py="5px"
                            >
                              Cancel
                            </Button>
                          </Flex>
                        </Flex>
                      ) : visibleSearchUser ? (
                        <Flex flexDirection="column" gap={2} width="100%">
                          <Flex flex={11} flexDirection="column" gap={2}>
                            <Flex gap={2} alignItems="center">
                              <Text flex={1}>Nama: </Text>
                              <Input
                                px={3}
                                py={1}
                                flex={3}
                                borderRadius={5}
                                border="1px solid"
                                width="100%"
                                name="name"
                                fontSize={{ sm: "xs", md: "sm" }}
                                placeholder="Input name"
                                onChange={(e) =>
                                  visibleSearchUser === "user1"
                                    ? onChangeUser1(e)
                                    : onChangeUser2(e)
                                }
                              />
                            </Flex>
                            <Flex gap={2} alignItems="center">
                              <Text flex={1}>Tanggal Lahir: </Text>
                              <Input
                                px={3}
                                py={1}
                                flex={3}
                                borderRadius={5}
                                border="1px solid"
                                width="100%"
                                type="date"
                                name="birth_date"
                                fontSize={{ sm: "xs", md: "sm" }}
                                placeholder="Input name"
                                onChange={(e) =>
                                  visibleSearchUser === "user1"
                                    ? onChangeUser1(e)
                                    : onChangeUser2(e)
                                }
                                inputProps={{
                                  min: "1940-01-01",
                                  max: "2040-12-31",
                                }}
                              />
                            </Flex>
                            <Flex gap={2} alignItems="center">
                              <Text flex={1}>Gender: </Text>
                              <Flex flex={3}>
                                <RadioGroup
                                  row
                                  id="gender"
                                  name="gender"
                                  onChange={(e) =>
                                    visibleSearchUser === "user1"
                                      ? onChangeUser1(e)
                                      : onChangeUser2(e)
                                  }
                                >
                                  <FormControlLabel
                                    value={1}
                                    control={<Radio id="gender" />}
                                    label="Female"
                                  />
                                  <FormControlLabel
                                    value={0}
                                    control={<Radio id="gender" />}
                                    label="Male"
                                  />
                                </RadioGroup>
                              </Flex>
                            </Flex>
                          </Flex>
                          <Flex flex={1} justifyContent="center">
                            <Button
                              bgColor={"white"}
                              color={"#3572EF"}
                              fontSize={{ sm: "xs", md: "sm" }}
                              fontWeight="bold"
                              borderRadius="5px"
                              borderWidth={1}
                              borderColor="#3572EF"
                              onClick={() => {
                                const targetUser =
                                  visibleSearchUser === "user1" ? user1 : user2;
                                if (targetUser?.birth_date) {
                                  const birthDate = new Date(
                                    targetUser.birth_date,
                                  );
                                  const minDate = new Date("1940-01-01");
                                  const maxDate = new Date("2040-12-31");
                                  if (
                                    birthDate < minDate ||
                                    birthDate > maxDate
                                  ) {
                                    setError(
                                      "Tanggal lahir tidak valid (1940-2040)",
                                    );
                                    return;
                                  }
                                }
                                setVisibleSearchUser(false);
                              }}
                              px={{ sm: "10px", md: "30px" }}
                              py="5px"
                            >
                              Save
                            </Button>
                          </Flex>
                        </Flex>
                      ) : (
                        <>
                          {user !== "guess" ? (
                            <>
                              <Button
                                bgColor={"blue.400"}
                                color={"white"}
                                fontSize={{ sm: "xs", md: "sm" }}
                                fontWeight="bold"
                                borderRadius="5px"
                                onClick={() => onSelectMe()}
                                px="10px"
                                py="5px"
                                flex={1}
                                disabled={user2 === user}
                              >
                                <Text
                                  overflow="hidden"
                                  fontSize={{ sm: "xs", md: "sm" }}
                                  whiteSpace="nowrap"
                                  textOverflow="ellipsis"
                                  isTruncated
                                  maxWidth="160px"
                                >
                                  {user?.name?.slice(0, 10)}
                                </Text>
                              </Button>
                              <Button
                                bgColor={"blue.400"}
                                color={"white"}
                                fontSize={{ sm: "xs", md: "sm" }}
                                fontWeight="bold"
                                borderRadius="5px"
                                onClick={() => {
                                  if (checkLogin()) {
                                    setVisibleSearchUser("user");
                                  }
                                }}
                                px="15px"
                                flex={1}
                                py="5px"
                              >
                                <Flex
                                  gap={2}
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <Icon as={Search2Icon} />
                                  <Text fontSize={{ sm: "xs", md: "sm" }}>
                                    Apps Users
                                  </Text>
                                </Flex>
                              </Button>
                              <Button
                                bgColor={"green.400"}
                                color={"white"}
                                fontSize={{ sm: "xs", md: "sm" }}
                                fontWeight="bold"
                                borderRadius="5px"
                                onClick={() => {
                                  if (checkLogin()) {
                                    setVisibleSearchUser("colleague");
                                  }
                                }}
                                px="15px"
                                py="5px"
                                flex={1}
                              >
                                <Flex
                                  gap={2}
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <Icon as={Search2Icon} />
                                  <Text fontSize={{ sm: "xs", md: "sm" }}>
                                    Colleague
                                  </Text>
                                </Flex>
                              </Button>
                              <Button
                                borderWidth={4}
                                bgColor="transparent"
                                borderColor="green.400"
                                color="#fff"
                                fontSize="sm"
                                fontWeight="bold"
                                borderRadius="5px"
                                px="10px"
                                py="5px"
                                onClick={() => {
                                  if (checkLogin()) {
                                    window.location.assign(
                                      "/dashboard/friend-list/add-colleague?from=matching",
                                    );
                                  }
                                }}
                              >
                                <Image
                                  src={Add}
                                  w={{ base: "25px", "3xl": "25px" }}
                                  h={{ base: "25px", "3xl": "25px" }}
                                  borderRadius="20px"
                                />
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                bgColor={"white"}
                                borderColor="#3572EF"
                                borderWidth={2}
                                color={"#3572EF"}
                                fontSize={{ sm: "xs", md: "sm" }}
                                fontWeight="bold"
                                borderRadius="5px"
                                onClick={() => {
                                  if (checkLogin()) {
                                    setVisibleSearchUser("user1");
                                  }
                                }}
                                px="15px"
                                flex={1}
                                py="5px"
                              >
                                <Flex
                                  gap={2}
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <Text fontSize={{ sm: "xs", md: "sm" }}>
                                    Input orang pertama
                                  </Text>
                                </Flex>
                              </Button>
                              <Button
                                bgColor={"white"}
                                color={"#059212"}
                                borderColor="#059212"
                                borderWidth={2}
                                fontSize={{ sm: "xs", md: "sm" }}
                                fontWeight="bold"
                                borderRadius="5px"
                                onClick={() => {
                                  if (checkLogin()) {
                                    setVisibleSearchUser("user2");
                                  }
                                }}
                                px="15px"
                                py="5px"
                                flex={1}
                              >
                                <Flex
                                  gap={2}
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <Text fontSize={{ sm: "xs", md: "sm" }}>
                                    Input orang kedua
                                  </Text>
                                </Flex>
                              </Button>
                            </>
                          )}
                        </>
                      )}
                    </Flex>
                    {visibleSearchUser !== "user1" &&
                      visibleSearchUser !== "user2" && (
                        <Flex
                          justifyContent={{ sm: "center" }}
                          width={{ sm: "100%" }}
                        >
                          <Button
                            bgColor={"red"}
                            color={"white"}
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="bold"
                            borderRadius="5px"
                            onClick={() => onRunMatching()}
                            px={{ sm: "10px", md: "30px" }}
                            py="5px"
                            disabled={
                              mode === 1 && user1?.gender === user2?.gender
                            }
                          >
                            Run the matching
                          </Button>
                        </Flex>
                      )}
                  </Flex>
                </Flex>
                <Flex
                  direction="row"
                  id="row-menu"
                  gap={{ sm: 3, md: 5 }}
                  flexWrap="wrap"
                >
                  {matching && activeCard !== 0 && (
                    <>
                      <Button
                        bgColor={
                          cardMatching.length === 0
                            ? "gray"
                            : activeCard === 1
                              ? "#3572EF"
                              : "white"
                        }
                        color={
                          activeCard === 1 || cardMatching.length === 0
                            ? "white"
                            : "#3572EF"
                        }
                        borderWidth={1}
                        borderColor="#3572EF"
                        fontSize={{ sm: "xs", md: "sm" }}
                        fontWeight="bold"
                        borderRadius="5px"
                        onClick={() => onClickCard(1)}
                        flex={{ sm: 1 }}
                        disabled={cardMatching.length === 0}
                        px={{ sm: "10px", md: "30px" }}
                        py="5px"
                      >
                        General match
                      </Button>
                      <Button
                        bgColor={
                          cardMatching.length === 0
                            ? "gray"
                            : activeCard === 2
                              ? "#3572EF"
                              : "white"
                        }
                        color={
                          activeCard === 2 || cardMatching.length === 0
                            ? "white"
                            : "#3572EF"
                        }
                        borderWidth={1}
                        borderColor="#3572EF"
                        fontSize={{ sm: "xs", md: "sm" }}
                        fontWeight="bold"
                        borderRadius="5px"
                        onClick={() => onClickCard(2)}
                        disabled={cardMatching.length === 0}
                        flex={{ sm: 1 }}
                        px={{ sm: "10px", md: "30px" }}
                        py="5px"
                      >
                        Daily match
                      </Button>
                    </>
                  )}
                </Flex>
                {matching && activeCard !== 0 && (
                  <Flex
                    direction="column"
                    padding={3}
                    borderWidth={1}
                    borderRadius={5}
                  >
                    <Flex
                      position="relative"
                      flexDirection="column"
                      width={{ md: "100%" }}
                      borderWidth={1}
                      borderRadius={15}
                      px={0}
                      py={5}
                      gap={5}
                    >
                      {mode !== matchedMode && (
                        <Flex
                          position="absolute"
                          zIndex={1}
                          bgColor="#efefefd9"
                          left={0}
                          width="100%"
                          height="100%"
                          top={0}
                          borderRadius={15}
                          alignItems="center"
                          justifyContent="center"
                          flexDirection="column"
                        >
                          <MdLock size={40} />
                          <Text>
                            Kamu Memilih Matching Lain, Klik Run The Matching
                            untuk melihat hasilnya
                          </Text>
                        </Flex>
                      )}

                      <Flex
                        flexDirection={{ md: "row" }}
                        px={{ sm: 0, md: 10 }}
                        py={5}
                        gap={10}
                        alignItems="center"
                      >
                        <Flex flexDirection="column" gap={5}>
                          <Flex
                            alignItems="center"
                            gap={1}
                            flexDirection="column"
                          >
                            <Avatar
                              src={matchedUser1.photo}
                              h={{ sm: "50px", md: "80px" }}
                              w={{ sm: "50px", md: "80px" }}
                              // border={{ sm: '1px solid', md: '4px solid' }}
                            />
                            <Flex flexDirection="column" textAlign="center">
                              <Text
                                textOverflow="ellipsis"
                                fontSize={{ sm: "xs", md: "sm" }}
                                overflow="hidden"
                                whiteSpace="nowrap"
                                maxW={32}
                              >
                                {matchedUser1.name}
                              </Text>
                              <Text fontSize={{ sm: "xs", md: "sm" }}>
                                {matchedUser1.gender == 0 ? "Male" : "Female"}
                              </Text>
                            </Flex>
                          </Flex>
                        </Flex>
                        <Flex direction="column" width="100%">
                          <Text
                            textAlign="center"
                            fontSize="lg"
                            fontWeight="bold"
                          >
                            {stats}%
                          </Text>
                          <LinearProgress
                            sx={{ height: 20, borderRadius: 3, width: "100%" }}
                            color={
                              mode === 0
                                ? "warning"
                                : mode === 1
                                  ? "error"
                                  : "info"
                            }
                            variant="determinate"
                            value={stats}
                          />
                          <Text
                            textAlign="center"
                            fontSize="sm"
                            fontWeight="bold"
                          >
                            {level}
                          </Text>
                        </Flex>
                        <Flex flexDirection="column" gap={5}>
                          <Flex
                            alignItems="center"
                            gap={1}
                            flexDirection="column"
                          >
                            <Avatar
                              src={matchedUser2.photo}
                              h={{ sm: "50px", md: "80px" }}
                              w={{ sm: "50px", md: "80px" }}
                              // border={{ sm: '1px solid', md: '4px solid' }}
                            />
                            <Flex flexDirection="column" textAlign="center">
                              <Text
                                textOverflow="ellipsis"
                                fontSize={{ sm: "xs", md: "sm" }}
                                overflow="hidden"
                                whiteSpace="nowrap"
                                maxW={32}
                              >
                                {matchedUser2.name}
                              </Text>
                              <Text fontSize={{ sm: "xs", md: "sm" }}>
                                {matchedUser2.gender == 0 ? "Male" : "Female"}
                              </Text>
                            </Flex>
                          </Flex>
                        </Flex>
                      </Flex>
                      {cardMatching.map((card, index) => (
                        <Flex position="relative">
                          <Flex direction="column" key={index} gap={1}>
                            <Text
                              fontWeight="bold"
                              textTransform="uppercase"
                              color="#B82132"
                              fontSize={{ sm: "sm", md: "md" }}
                            >
                              {card?.title}
                            </Text>
                            <Flex
                              position="relative"
                              flexDirection="column"
                              borderWidth={0.5}
                              borderRadius={15}
                              padding={2}
                              borderColor="lightgrey"
                            >
                              {index > 0 && (
                                <Flex
                                  position="absolute"
                                  zIndex={0}
                                  bgColor="#efefefd9"
                                  left={0}
                                  width="100%"
                                  height="100%"
                                  top={0}
                                  borderRadius={15}
                                  alignItems="center"
                                  justifyContent="center"
                                  flexDirection="column"
                                  cursor="pointer"
                                  onClick={() => onClickOpen("")}
                                >
                                  <MdLock size={40} />
                                  <Text>Unlocked</Text>
                                </Flex>
                              )}
                              {/* {card.texts.map((text) => (
                              <> */}
                              {/* {card.texts[0].map((item, i) => {
                                    return ( */}
                              <Flex direction="column" gap={1}>
                                <Text
                                  fontWeight="bold"
                                  fontSize={{ sm: "xs", md: "md" }}
                                >
                                  {card.texts[0][0]?.title != "null" &&
                                    card.texts[0][0]?.title}
                                </Text>
                                <Text
                                  textOverflow="ellipsis"
                                  whiteSpace="pre-line"
                                  fontSize={{ sm: "xs", md: "md" }}
                                >
                                  {card.texts[0][0]?.text}
                                </Text>
                                <Text
                                  color="#3D3BF3"
                                  fontSize={{ sm: "xs", md: "sm" }}
                                  fontStyle="italic"
                                  textAlign="end"
                                  mt={0}
                                  cursor="pointer"
                                  onClick={() =>
                                    onClickOpen(card.texts[0][0]?.text)
                                  }
                                >
                                  {isUnlocked && card.texts[0][0]?.text !== open
                                    ? "Baca lengkap..."
                                    : isUnlocked &&
                                        card.texts[0][0]?.text === open
                                      ? "Baca lengkap..."
                                      : "Baca lengkap..."}
                                </Text>
                              </Flex>
                              {/* )
                                  })
                                } */}
                              {/* </>
                            ))} */}
                            </Flex>
                          </Flex>
                        </Flex>
                      ))}
                    </Flex>
                  </Flex>
                )}
              </Flex>
            </Flex>
          </Box>

          {/* MOBILE VIEW */}
          <Flex
            display={{ base: "flex", md: "none" }}
            direction="column"
            gap={3}
            width="100%"
            pb="150px"
          >
            {/* 1. Top Tabs */}
            <Flex
              width="100%"
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="12px"
              overflow="hidden"
              position="sticky"
              top="55px"
              zIndex="999"
            >
              {["Partnership", "Romance", "Friendship"].map((label, idx) => {
                const isActive = mode === idx;
                const activeColor =
                  idx === 0 ? "orange.400" : idx === 1 ? "#FF0080" : "blue.500";
                return (
                  <Button
                    key={label}
                    flex={1}
                    size="sm"
                    variant="unstyled"
                    bg={isActive ? activeColor : "white"}
                    color={isActive ? "white" : "gray.800"}
                    borderRadius={0}
                    fontSize="md"
                    fontWeight="bold"
                    height="40px"
                    _focus={{ boxShadow: "none" }}
                    onClick={() => setMode(idx)}
                  >
                    {label}
                  </Button>
                );
              })}
            </Flex>

            {/* 2. Main Matching Card */}
            <Box
              bg="white"
              borderRadius="xl"
              shadow="sm"
              border="1px solid"
              borderColor="blue.100"
              p={4}
            >
              <Text textAlign="center" fontWeight="normal" mb={4} fontSize="xs">
                {isSubscribed
                  ? `Sedang Berlangganan, masih ${quotaRun} kali Matching`
                  : user === "guess"
                    ? ""
                    : `Free ${quotaRun} kali Matching`}
              </Text>

              <Flex justify="center" align="center" gap={6} mb={6}>
                {/* User 1 */}
                <Box position="relative">
                  <Avatar
                    size="xl"
                    width="65px"
                    height="65px"
                    src={user1?.photo}
                    icon={
                      <PersonSvg
                        color={
                          mode === 0
                            ? "orange"
                            : mode === 1
                              ? "#FF0080"
                              : "#3182CE"
                        }
                        style={{ width: "100%", height: "100%" }}
                      />
                    }
                    bg={
                      user1
                        ? "transparent"
                        : mode === 1
                          ? "#FF0080"
                          : mode === 0
                            ? "orange"
                            : "blue.500"
                    }
                  >
                    {user1 && (
                      <AvatarBadge
                        as={ChakraIconButton}
                        size="sm"
                        rounded="full"
                        top="-5px"
                        right="-5px"
                        colorScheme="red"
                        aria-label="remove"
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          padding: 5,
                          bottom: "unset",
                        }}
                        icon={<CloseIcon boxSize={2} />}
                        onClick={() => onRemoveUser(1)}
                      />
                    )}
                  </Avatar>
                  {user1 && (
                    <Flex direction="column" alignItems="center">
                      <Text
                        fontSize={{ sm: "xs", md: "sm" }}
                        isTruncated
                        maxWidth="130px"
                      >
                        {user1.name?.slice(0, 10)}
                      </Text>
                      <Text fontSize={{ sm: "xs", md: "sm" }}>
                        {user1.gender == 0 ? "Male" : "Female"}
                      </Text>
                    </Flex>
                  )}
                </Box>

                {/* User 2 */}
                <Box position="relative">
                  <Avatar
                    size="xl"
                    width="65px"
                    height="65px"
                    src={user2?.photo}
                    icon={
                      <PersonSvg
                        color={
                          mode === 0
                            ? "orange"
                            : mode === 1
                              ? "#FF0080"
                              : "#3182CE"
                        }
                        style={{ width: "100%", height: "100%" }}
                      />
                    }
                    bg={
                      user2
                        ? "transparent"
                        : mode === 1
                          ? "#FF0080"
                          : mode === 0
                            ? "orange"
                            : "blue.500"
                    }
                  >
                    {user2 && (
                      <AvatarBadge
                        as={ChakraIconButton}
                        size="sm"
                        rounded="full"
                        top="-5px"
                        right="-5px"
                        colorScheme="red"
                        aria-label="remove"
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          padding: 5,
                          bottom: "unset",
                        }}
                        icon={<CloseIcon boxSize={2} />}
                        onClick={() => onRemoveUser(2)}
                      />
                    )}
                  </Avatar>
                  {user2 && (
                    <Flex direction="column" alignItems="center">
                      <Text
                        fontSize={{ sm: "xs", md: "sm" }}
                        isTruncated
                        maxWidth="130px"
                      >
                        {user2.name?.slice(0, 10)}
                      </Text>
                      <Text fontSize={{ sm: "xs", md: "sm" }}>
                        {user2.gender == 0 ? "Male" : "Female"}
                      </Text>
                    </Flex>
                  )}
                </Box>
              </Flex>

              {/* Actions */}
              {visibleSearchUser ? (
                <Box mb={4} p={3} bg="gray.50" borderRadius="md">
                  <Text fontSize="xs" fontWeight="bold" mb={2}>
                    Search{" "}
                    {visibleSearchUser === "colleague"
                      ? "Colleague"
                      : "App User"}
                    :
                  </Text>
                  <Input
                    placeholder="Type a name..."
                    bg="white"
                    mb={2}
                    size="sm"
                    onChange={onChangeSearch}
                  />
                  {searchData.length > 0 && (
                    <Box
                      maxHeight="150px"
                      overflowY="auto"
                      bg="white"
                      shadow="sm"
                      borderRadius="md"
                      mb={2}
                    >
                      {searchData.map((data, idx) => (
                        <Button
                          key={idx}
                          width="100%"
                          justifyContent="start"
                          variant="ghost"
                          size="sm"
                          onClick={() => onSelectUser(data, visibleSearchUser)}
                        >
                          <Text isTruncated>{data.name}</Text>
                        </Button>
                      ))}
                    </Box>
                  )}
                  <Flex justify="end">
                    <Button
                      size="xs"
                      colorScheme="red"
                      variant="outline"
                      onClick={() => setVisibleSearchUser(false)}
                    >
                      Cancel
                    </Button>
                  </Flex>
                </Box>
              ) : (
                <Flex
                  gap={2}
                  justify="center"
                  mb={6}
                  flexWrap="wrap"
                  marginLeft="20px"
                >
                  <Button
                    flex={1}
                    colorScheme="green"
                    bg="#00C853"
                    size="sm"
                    color="white"
                    onClick={onSelectMe}
                    isDisabled={!!user1}
                    _hover={{ bg: "#00E676" }}
                    borderRadius="5px"
                    fontSize="xs"
                    px={4}
                  >
                    {user && user !== "guess"
                      ? user.name?.split(" ")[0]?.slice(0, 10) || "Me"
                      : "username"}
                  </Button>
                  <Button
                    colorScheme="blue"
                    flex={1}
                    bg="green.600"
                    size="sm"
                    color="white"
                    onClick={() => {
                      if (checkLogin()) {
                        setSearchData([]);
                        setVisibleSearchUser("user");
                      }
                    }}
                    _hover={{ bg: "#2962FF" }}
                    borderRadius="5px"
                    fontSize="xs"
                    px={4}
                  >
                    Apps user
                  </Button>
                  <Button
                    colorScheme="purple"
                    flex={1}
                    bg="green.900"
                    size="sm"
                    color="white"
                    onClick={() => {
                      if (checkLogin()) {
                        setSearchData([]);
                        setVisibleSearchUser("colleague");
                      }
                    }}
                    _hover={{ bg: "#7C4DFF" }}
                    borderRadius="5px"
                    fontSize="xs"
                    px={4}
                    py={0}
                  >
                    Colleague
                  </Button>
                  <ChakraIconButton
                    aria-label="Add Colleague"
                    icon={<Image src={Add} w="20px" />}
                    size="sm"
                    variant="ghost"
                    colorScheme="purple"
                    onClick={() => {
                      if (checkLogin()) {
                        window.location.assign(
                          "/dashboard/friend-list/add-colleague?from=matching",
                        );
                      }
                    }}
                  />
                </Flex>
              )}
              <Flex justify="center">
                <Button
                  bg="#0046FF"
                  color="white"
                  size="sm"
                  borderRadius="5px"
                  fontSize="xs"
                  onClick={onRunMatching}
                  py={1}
                  px={4}
                  _hover={{ bg: "#2962FF" }}
                  boxShadow="0 4px 6px rgba(0, 70, 255, 0.3)"
                >
                  Run The Matching
                </Button>
              </Flex>
            </Box>

            <Flex
              direction="row"
              id="row-menu"
              gap={{ sm: 3, md: 5 }}
              flexWrap="wrap"
            >
              {matching && activeCard !== 0 && (
                <>
                  <Button
                    bgColor={
                      cardMatching.length === 0
                        ? "gray"
                        : activeCard === 1
                          ? "#3572EF"
                          : "white"
                    }
                    color={
                      activeCard === 1 || cardMatching.length === 0
                        ? "white"
                        : "#3572EF"
                    }
                    borderWidth={1}
                    borderColor="#3572EF"
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                    borderRadius="5px"
                    onClick={() => onClickCard(1)}
                    flex={{ sm: 1 }}
                    disabled={cardMatching.length === 0}
                    px={{ sm: "10px", md: "30px" }}
                    py="5px"
                  >
                    General match
                  </Button>
                  <Button
                    bgColor={
                      cardMatching.length === 0
                        ? "gray"
                        : activeCard === 2
                          ? "#3572EF"
                          : "white"
                    }
                    color={
                      activeCard === 2 || cardMatching.length === 0
                        ? "white"
                        : "#3572EF"
                    }
                    borderWidth={1}
                    borderColor="#3572EF"
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                    borderRadius="5px"
                    onClick={() => onClickCard(2)}
                    disabled={cardMatching.length === 0}
                    flex={{ sm: 1 }}
                    px={{ sm: "10px", md: "30px" }}
                    py="5px"
                  >
                    Daily match
                  </Button>
                </>
              )}
            </Flex>
            {matching && activeCard !== 0 && (
              <Flex
                direction="column"
                padding={3}
                borderWidth={1}
                borderRadius={5}
              >
                <Flex
                  position="relative"
                  flexDirection="column"
                  width={{ md: "100%" }}
                  borderWidth={1}
                  borderRadius={15}
                  px={0}
                  py={5}
                  gap={5}
                >
                  {mode !== matchedMode && (
                    <Flex
                      position="absolute"
                      zIndex={1}
                      bgColor="#efefefd9"
                      left={0}
                      width="100%"
                      height="100%"
                      top={0}
                      borderRadius={15}
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <MdLock size={40} />
                      <Text>
                        Kamu Memilih Matching Lain, Klik Run The Matching untuk
                        melihat hasilnya
                      </Text>
                    </Flex>
                  )}

                  <Flex
                    flexDirection={{ md: "row" }}
                    px={{ sm: 0, md: 10 }}
                    py={5}
                    gap={10}
                    alignItems="center"
                  >
                    <Flex flexDirection="column" gap={5}>
                      <Flex alignItems="center" gap={1} flexDirection="column">
                        <Avatar
                          src={matchedUser1.photo}
                          h={{ sm: "50px", md: "80px" }}
                          w={{ sm: "50px", md: "80px" }}
                          // border={{ sm: '1px solid', md: '4px solid' }}
                        />
                        <Flex flexDirection="column" textAlign="center">
                          <Text
                            textOverflow="ellipsis"
                            fontSize={{ sm: "xs", md: "sm" }}
                            overflow="hidden"
                            whiteSpace="nowrap"
                            maxW={32}
                          >
                            {matchedUser1.name}
                          </Text>
                          <Text fontSize={{ sm: "xs", md: "sm" }}>
                            {matchedUser1.gender == 0 ? "Male" : "Female"}
                          </Text>
                        </Flex>
                      </Flex>
                    </Flex>
                    <Flex direction="column" width="100%">
                      <Text textAlign="center" fontSize="lg" fontWeight="bold">
                        {stats}%
                      </Text>
                      <LinearProgress
                        sx={{ height: 20, borderRadius: 3, width: "100%" }}
                        color={
                          mode === 0 ? "warning" : mode === 1 ? "error" : "info"
                        }
                        variant="determinate"
                        value={stats}
                      />
                      <Text textAlign="center" fontSize="sm" fontWeight="bold">
                        {level}
                      </Text>
                    </Flex>
                    <Flex flexDirection="column" gap={5}>
                      <Flex alignItems="center" gap={1} flexDirection="column">
                        <Avatar
                          src={matchedUser2.photo}
                          h={{ sm: "50px", md: "80px" }}
                          w={{ sm: "50px", md: "80px" }}
                          // border={{ sm: '1px solid', md: '4px solid' }}
                        />
                        <Flex flexDirection="column" textAlign="center">
                          <Text
                            textOverflow="ellipsis"
                            fontSize={{ sm: "xs", md: "sm" }}
                            overflow="hidden"
                            whiteSpace="nowrap"
                            maxW={32}
                          >
                            {matchedUser2.name}
                          </Text>
                          <Text fontSize={{ sm: "xs", md: "sm" }}>
                            {matchedUser2.gender == 0 ? "Male" : "Female"}
                          </Text>
                        </Flex>
                      </Flex>
                    </Flex>
                  </Flex>
                  {cardMatching.map((card, index) => (
                    <Flex position="relative">
                      <Flex direction="column" key={index} gap={1}>
                        <Text
                          fontWeight="bold"
                          textTransform="uppercase"
                          color="#B82132"
                          fontSize={{ sm: "sm", md: "md" }}
                        >
                          {card?.title}
                        </Text>
                        <Flex
                          position="relative"
                          flexDirection="column"
                          borderWidth={0.5}
                          borderRadius={15}
                          padding={2}
                          borderColor="lightgrey"
                        >
                          {index > 0 && (
                            <Flex
                              position="absolute"
                              zIndex={0}
                              bgColor="#efefefd9"
                              left={0}
                              width="100%"
                              height="100%"
                              top={0}
                              borderRadius={15}
                              alignItems="center"
                              justifyContent="center"
                              flexDirection="column"
                              cursor="pointer"
                              onClick={() => onClickOpen("")}
                            >
                              <MdLock size={40} />
                              <Text>Unlocked</Text>
                            </Flex>
                          )}
                          {/* {card.texts.map((text) => (
                              <> */}
                          {/* {card.texts[0].map((item, i) => {
                                    return ( */}
                          <Flex direction="column" gap={1}>
                            <Text
                              fontWeight="bold"
                              fontSize={{ sm: "xs", md: "md" }}
                            >
                              {card.texts[0][0]?.title != "null" &&
                                card.texts[0][0]?.title}
                            </Text>
                            <Text
                              textOverflow="ellipsis"
                              whiteSpace="pre-line"
                              fontSize={{ sm: "xs", md: "md" }}
                            >
                              {card.texts[0][0]?.text}
                            </Text>
                            <Text
                              color="#3D3BF3"
                              fontSize={{ sm: "xs", md: "sm" }}
                              fontStyle="italic"
                              textAlign="end"
                              mt={0}
                              cursor="pointer"
                              onClick={() =>
                                onClickOpen(card.texts[0][0]?.text)
                              }
                            >
                              {isUnlocked && card.texts[0][0]?.text !== open
                                ? "Baca lengkap..."
                                : isUnlocked && card.texts[0][0]?.text === open
                                  ? "Baca lengkap..."
                                  : "Baca lengkap..."}
                            </Text>
                          </Flex>
                          {/* )
                                  })
                                } */}
                          {/* </>
                            ))} */}
                        </Flex>
                      </Flex>
                    </Flex>
                  ))}
                </Flex>
              </Flex>
            )}

            {/* 3. Cara Matching */}
            <Box
              bg="white"
              borderRadius="xl"
              shadow="sm"
              border="1px solid"
              borderColor="blue.100"
              p={4}
              pt={2}
            >
              <Flex
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <Text fontWeight="bold" mb={2} mx={"-10px"} fontSize="sm">
                  Cara Matching :
                </Text>
                {(!user || user === "guess") && (
                  <Flex justify="flex-end">
                    <Button
                      size="xs"
                      bgColor="#0045B0"
                      color="white"
                      borderRadius="5px"
                      fontSize="sm"
                      px={3}
                      py={1}
                      onClick={() => {
                        localStorage.setItem("redirect_url", "/matching");
                        window.location.assign("/login");
                      }}
                      _hover={{ bg: "#00348a" }}
                    >
                      Daftar Gratis
                    </Button>
                  </Flex>
                )}
              </Flex>
              <OrderedList fontSize="xs" spacing={1} pl={4} color="gray.700">
                <ListItem>
                  <Flex direction="column" gap={2}>
                    <Text>
                      Untuk melakukan Matching silakan <b>DAFTAR / LOGIN</b>{" "}
                      terlebih dahulu.
                    </Text>
                  </Flex>
                </ListItem>
                <ListItem>
                  Pilih tipe matching (Partnership, Romance, Friendship).
                </ListItem>
                <ListItem>
                  Pilih orang yang akan kamu maching (User Sendiri, User Apps,
                  Colleague).
                </ListItem>
                <ListItem>
                  Untuk menambah data orang input manual: klik Icon Orang+.
                </ListItem>
                <ListItem>Selanjutnya klik button Run The Matching.</ListItem>
              </OrderedList>
            </Box>

            {/* 4. Subscription */}
            <Box
              bg="white"
              borderRadius="xl"
              shadow="sm"
              border="1px solid"
              borderColor="blue.100"
              p={4}
            >
              <Text fontWeight="bold" mb={3} mx={"-10px"} fontSize="sm">
                Tertarik Berlangganan ?
              </Text>
              <Flex gap={2} mb={3} mx={"-10px"}>
                <Button
                  flex={1}
                  size="sm"
                  colorScheme="green"
                  bg={matchDay === 0 ? "blue.300" : "white"}
                  color={matchDay === 0 ? "white" : "gray.600"}
                  border="1px solid"
                  borderColor={matchDay === 0 ? "blue.300" : "gray.300"}
                  variant={matchDay === 0 ? "solid" : "outline"}
                  onClick={() => setMatchDay(0)}
                  fontSize="xs"
                >
                  5 Hari
                </Button>
                <Button
                  flex={1}
                  size="sm"
                  colorScheme="green"
                  bg={matchDay === 1 ? "blue.300" : "white"}
                  color={matchDay === 1 ? "white" : "gray.600"}
                  border="1px solid"
                  borderColor={matchDay === 1 ? "blue.300" : "gray.300"}
                  variant={matchDay === 1 ? "solid" : "outline"}
                  onClick={() => setMatchDay(1)}
                  fontSize="xs"
                >
                  10 Hari
                </Button>
              </Flex>
              <OrderedList fontSize="xs" spacing={1} pl={4} color="gray.700">
                <ListItem>
                  {matchDay === 0 ? "10X" : "15X"} Run The Matching langganan
                  per hari.
                </ListItem>
                <ListItem>
                  1 Hasil Matching Lengkap dapat kamu simpan selama{" "}
                  {matchDay === 0 ? "5" : "10"} hari berlangganan.
                </ListItem>
                <ListItem>
                  Kamu bisa mengganti Matching yang tersimpan setiap hari 1X.
                </ListItem>
                <ListItem>
                  Hasil Matching yang kamu simpan akan expired pada jam 00.00.
                </ListItem>
                <ListItem>
                  Untuk Jenis Matching yang belum berlangganan kamu hanya dapat
                  melakukan 2X Run The Matching saja.
                </ListItem>
              </OrderedList>
              <Flex
                justify="space-between"
                align="center"
                maxWidth="600px"
                mx="auto"
                mt="10px"
              >
                <Box>
                  <Text fontSize="xs" color="gray.600">
                    Hanya dengan Berlangganan
                  </Text>
                  <Text fontSize="xs" fontWeight="bold">
                    Rp.{" "}
                    {matchDay === 0
                      ? products.find((p) => p.code === "MM5")?.price
                        ? formatPrice(
                            products.find((p) => p.code === "MM5")?.price,
                          )
                        : "5.000"
                      : products.find((p) => p.code === "MM10")?.price
                        ? formatPrice(
                            products.find((p) => p.code === "MM10")?.price,
                          )
                        : "10.000"}
                    ,- untuk {matchDay === 0 ? "5" : "10"} Hari
                  </Text>
                </Box>
                {user && user !== "guess" && (
                  <Button
                    colorScheme="blue"
                    bg="#0046FF"
                    size="sm"
                    onClick={() => setIsShowPrincing(true)}
                    fontSize="xs"
                    borderRadius="5px"
                    _hover={{ bg: "#2962FF" }}
                    color="white"
                    px={"12px"}
                    py={2}
                  >
                    Berlangganan Matching
                  </Button>
                )}
              </Flex>
            </Box>
          </Flex>
        </Flex>
      </div>
      <Footer />
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        maxWidth="xs"
        fullWidth
        open={showDialog}
      >
        <DialogTitle
          sx={{ m: 0, p: 3, backgroundColor: "#DDF4E7" }}
          id="customized-dialog-title"
        >
          Deep Dive
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Flex
            flexDirection="row"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <Text>Kamu Dapat Menyimpan 1 Hasil Matching / Hari</Text>
            <Text>Apakah Kamu Akan Menyimpan Hasil Matching ini ?</Text>
          </Flex>
        </DialogContent>
        <DialogActions>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"green"}
            color="white"
            fontSize="sm"
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => onSaveMatching()}
            // disabled={pagination.page === pagination.max}
          >
            Save
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <BootstrapDialog
        onClose={handleCloseLimit}
        aria-labelledby="customized-dialog-title"
        maxWidth="xs"
        fullWidth
        open={limitMatching}
      >
        <DialogTitle
          sx={{ m: 0, p: 3, backgroundColor: "#DDF4E7" }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseLimit}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon width={3} />
        </IconButton>
        <DialogContent>
          <Flex
            flexDirection="column"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <Text>
              Kamu hanya memiliki {isSubscribed ? "10" : "2"} X Matching/Hari.
            </Text>
            <Text>Mau lebih banyak?</Text>
            <Text>Ayo berlangganan!</Text>
          </Flex>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"green"}
            color="white"
            fontSize="sm"
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => {
              handleCloseLimit();
              setIsShowPrincing(true);
            }}
            // disabled={pagination.page === pagination.max}
          >
            Ya
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <BootstrapDialog
        onClose={handleCloseSubscription}
        aria-labelledby="customized-dialog-title"
        maxWidth="xs"
        fullWidth
        open={isOpenSubscription}
      >
        <DialogTitle
          sx={{ m: 0, p: 3, backgroundColor: "#DDF4E7" }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseSubscription}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon width={3} />
        </IconButton>
        <DialogContent>
          <Flex
            flexDirection="column"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <Text>
              Untuk Membaca Lengkap hasil Matching Eksklusif hanya untuk yang
              berlangganan.
            </Text>
            <Text>Ayo berlangganan!</Text>
          </Flex>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"green"}
            color="white"
            fontSize="sm"
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => {
              handleCloseLimit();
              setIsShowPrincing(true);
            }}
            // disabled={pagination.page === pagination.max}
          >
            Ya
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <BootstrapDialog
        onClose={handleCloseReplace}
        aria-labelledby="customized-dialog-title"
        maxWidth="xs"
        fullWidth
        open={isShowReplace}
      >
        <DialogTitle
          sx={{ m: 0, p: 3, backgroundColor: "#DDF4E7" }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseReplace}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon width={3} />
        </IconButton>
        <DialogContent>
          <Flex
            flexDirection="column"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <Text>
              Apakah Kamu Akan Mengganti Hasil Matching Yang Sudah Kamu Simpan
              Sebelumnya, dengan Matching ini ?
            </Text>
          </Flex>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"green"}
            color="white"
            fontSize="sm"
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => onHandleReplace()}
            // disabled={pagination.page === pagination.max}
          >
            Ya
          </Button>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"green"}
            color="white"
            fontSize="sm"
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={handleCloseReplace}
            // disabled={pagination.page === pagination.max}
          >
            Tidak
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <BootstrapDialog
        onClose={handleCloseLimitSave}
        aria-labelledby="customized-dialog-title"
        maxWidth="xs"
        fullWidth
        open={isShowLimitSave}
      >
        <DialogTitle
          sx={{ m: 0, p: 3, backgroundColor: "#DDF4E7" }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseLimitSave}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon width={3} />
        </IconButton>
        <DialogContent>
          <Flex
            flexDirection="column"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <Text>Hari ini sudah menyimpan 1 Hasil Matching</Text>
            <Text>Kamu dapat mengganti Matching yang disimpan Besok Hari</Text>
          </Flex>
        </DialogContent>
      </BootstrapDialog>
      <BootstrapDialog
        onClose={handleClosePricing}
        maxWidth="md"
        fullWidth
        open={isShowPricing}
      >
        <DialogTitle
          sx={{ m: 0, p: 3, backgroundColor: "#DDF4E7" }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClosePricing}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon width={3} />
        </IconButton>
        <DialogContent>
          <Flex
            flexDirection="column"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <PricingMatching
              user={user}
              product={service?.matching}
              mode={mode}
            />
          </Flex>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
};

export default Matching;
